import validate from 'validate.js'
import { useTranslation } from '@mc/i18n'
import { privacyPath, termsPath } from 'libs/paths'
// TODO: Use useEmailCapture and getCartEmailCookie from @mc/email-capture
// extra note: the useEmailCapture from next fires 'Cart Email Capture', but @mc/email-capture fires 'Email Capture'
import { getCartEmailCookie, useEmailCapture } from 'libs/utils/account'

export const useEmailSignup = ({ showPricing = true, trackProps }) => {
  const { t } = useTranslation('@mc/next')
  const { loading, error, onCheckEmail } = useEmailCapture()

  const onSubmit = ({ homeGuestEmail }) => {
    onCheckEmail({
      ...trackProps,
      email: homeGuestEmail,
    })
  }

  // TODO: This is already handled by @mc/email-capture so we could replace it.
  const validateForm = (values) =>
    validate(values, CONSTRAINTS, { fullMessages: false })

  const persistedEmail = getCartEmailCookie()

  const CONSTRAINTS = {
    homeGuestEmail: {
      presence: { message: t('home.hero.emailRequired') },
      email: { message: t('home.hero.emailInvalid') },
    },
  }

  const emailFieldProps = {
    name: 'homeGuestEmail',
    id: 'homeGuestEmail',
    type: 'email',
    label: t('home.hero.emailLabel'),
    placeholder: t('home.hero.emailPlaceholder'),
    initialValue: persistedEmail,
    autoComplete: 'email',
    required: true,
  }

  const showEmailInputError = !loading && error

  return {
    emailFieldProps,
    loading,
    privacyPath: privacyPath(),
    showEmailInputError,
    showPricingText: showPricing,
    termsPath: termsPath(),
    onSubmit,
    validateForm,
  }
}
